/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：初始化 根据拥有的权限加载模块
 * 更新记录: 
 */
import { Injectable, NgModuleFactoryLoader, NgModuleRef } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class LazyDashboardTitleModules {

  constructor(
    private router:Router, //获取路由数据  拿到路由地址
    private loader: NgModuleFactoryLoader //初始化数据
  ) { }

  private moduleRef: NgModuleRef<any>; //获取模块对象

  /**
   * 初始化加载数据
   * @param modules  //获取权限的模块数据
   */
  load(modules) {
    let areas = []; //保存获取到模块的地址
    if (this.moduleRef) {
      return Promise.resolve();
    }
    //根据路由的code 和获取权限的code 判断是否有该模块
    this.router.config[0].children.forEach(el=>{
      if(modules.filter(x=>x.functionCode.toLowerCase() ==el.path.toLowerCase()).length>0){
        areas.push(el.loadChildren)
      }
    })
    //加载模块
    areas.forEach(router =>{
      this.loader.load(router).then(ModuleFactory => {
        // this.moduleRef = ModuleFactory.create(this.injector);
      })
    })
  
  }
}
